angular.module('leftPaneModule')
  .controller('LeftPaneDistrictController', [
    '$scope',
    '$rootScope',
    'districtApi',
    'cancelableResourceManager',
    'authentication',
    'edxReportItemService',
    'timeframe',
    function (
        $scope,
        $rootScope,
        $districtApi,
        $cancelableResourceManager,
        dblAuthentication,
        edxReportItemService,
        timeframe) {

      var updateDistrictData = function () {
          var promise = $districtApi.getDistrictData(function (districtData) {
              timeframe.getYearListSubject().onNext(districtData.years);
              // deprecated: use timeframe.getYearListSubject instead of broadcast
              $rootScope.$broadcast('updateYears', districtData.years);
              $scope.districtData = districtData;
          });
          $cancelableResourceManager.add(promise);
      };

      var initializeDateTimes = function () {
          var start = new Date();
          start.setHours(8, 0, 0, 0);
          $scope.startTime = start;

          var end = new Date();
          end.setHours(16, 30, 0, 0);
          $scope.endTime = end;
      };

      var initializeData = function (item) {
          $scope.item = item;
          initializeDateTimes();
          updateDistrictData();

          $scope.viewType = dblAuthentication.growthAsFraction() ? 'fractionMode' : 'percentMode';
      };

      var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(initializeData);

      var initializeItemSettings = function (e, settingsItem) {
          $scope.districtSettings = settingsItem;
      };
      $scope.$on('settingsItemReady', initializeItemSettings);

      $scope.$on('$destroy', function () {
          itemSubscription.dispose();
      });
  }]);
